import { Button } from '@react-spectrum/s2';

// The shared draft-review fork for a standalone monitor: activate it directly,
// or (when it's one of several items in a setup funnel) approve this step so the
// funnel advances. It is deliberately presentational — every flag and handler is
// computed by the owning panel and passed in — so it carries NO pause/resume UI
// and NO state machine. Those diverge across the existing monitor panels and
// stay bespoke there.
interface MonitorPanelFooterProps {
	// Label for the standalone activate button (e.g. "Start monitoring").
	activateLabel: string;
	isActivateDisabled: boolean;
	// true => render the funnel "Approve" button; false => the activate button.
	isFunnelSibling: boolean;
	onActivate: () => void;
	onApprove: () => void;
}

export const MonitorPanelFooter = ({
	activateLabel,
	isActivateDisabled,
	isFunnelSibling,
	onActivate,
	onApprove,
}: MonitorPanelFooterProps) => {
	if (isFunnelSibling) {
		return (
			<Button
				type="button"
				variant="accent"
				onPress={onApprove}
				isDisabled={isActivateDisabled}
			>
				Approve
			</Button>
		);
	}
	return (
		<Button
			type="button"
			variant="accent"
			onPress={onActivate}
			isDisabled={isActivateDisabled}
		>
			{activateLabel}
		</Button>
	);
};
